import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { StorageService } from 'app/services/storage.service';
import { KeysStorage } from 'app/comum/keys-storage';
import { AutenticacaoService } from 'app/services/autenticacao.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const autenticacaoService = inject(AutenticacaoService);
    const storage = inject(StorageService);
    const router = inject(Router);
    const snackBar = inject(MatSnackBar);
    const modalService = inject(NgbModal);

    if (autenticacaoService.isAuthenticated()) {
        const token = 'Bearer ' + storage.get(KeysStorage.tokenJwt());
        req = req.clone({
            setHeaders: {
                Authorization: token
            }
        });
    }

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
                if (req.url.includes('/autenticacao/autenticar')) {
                    return throwError(() => error);
                }
                snackBar.dismiss();
                modalService.dismissAll();
                router.navigate(['/login']);
                autenticacaoService.logout();
                return EMPTY;
            }
            return throwError(() => error);
        })
    );
};
